// extracted by mini-css-extract-plugin
module.exports = {"containerArquivo":"Arquivos_containerArquivo__2O-yh","arquivoImagem":"Arquivos_arquivoImagem__3mEvE","descricao":"Arquivos_descricao__3KGtp","botao":"Arquivos_botao__3VqJp"};